import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';
import theme from 'react/shared/theme/Theme';
import PALETTE from 'react/shared/theme/palette';
import { pressedEnterOrSpaceButton } from 'react/shared/utils/KeyboardEvents';

const useStyles = makeStyles(() => ({
  imageListWrapper: {
    marginBottom: theme.spacing(3),
  },
  imageList: {
    flexWrap: 'nowrap',
  },
  dotWrapper: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  active: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    background: PALETTE.emerald,
    '&:hover': {
      background: PALETTE.evergreen,
    },
  },
  inactive: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    background: PALETTE.emeraldLight,
    '&:hover': {
      background: PALETTE.emerald,
    },
  },
}));

export default function HorizontalImageList({ imageList, imageListProps = {} }) {
  const classes = useStyles();
  const imageListEl = useRef(null);
  const [activeCard, setActiveCard] = useState(1);

  const handleScroll = () => {
    const { scrollLeft, scrollWidth } = imageListEl.current;
    const card1Active = scrollWidth / 4 > scrollLeft;
    setActiveCard(card1Active ? 1 : 2);
  };

  const handleScrollDot1OnClick = () => {
    imageListEl.current.scrollLeft = 0;
    setActiveCard(1);
  };

  const handleScrollDot1OnKeyDown = (ev) => {
    if (pressedEnterOrSpaceButton(ev)) {
      ev.preventDefault();
      imageListEl.current.scrollLeft = 0;
      setActiveCard(1);
    }
  };

  const handleScrollDot2OnClick = () => {
    imageListEl.current.scrollLeft = imageListEl.current.scrollWidth / 2;
    setActiveCard(2);
  };

  const handleScrollDot2OnKeyDown = (ev) => {
    if (pressedEnterOrSpaceButton(ev)) {
      ev.preventDefault();
      imageListEl.current.scrollLeft = imageListEl.current.scrollWidth / 2;
      setActiveCard(2);
    }
  };

  return (
    <>
      <div className={classes.imageListWrapper}>
        <ImageList
          className={classes.imageList}
          cols={1}
          gap={18}
          onScroll={handleScroll}
          ref={imageListEl}
          rowHeight="auto"
          tabIndex={0}
        >
          {imageList.map((Card, i) => (
            <ImageListItem key={`card-${i}`}>
              <Card {...imageListProps} />
            </ImageListItem>
          ))}
        </ImageList>
      </div>
      <div className={classes.dotWrapper}>
        <div
          aria-label="Administrator info panel"
          className={activeCard === 1 ? classes.active : classes.inactive}
          data-testid="dot-1"
          key={`dot-1-${activeCard}`}
          onClick={handleScrollDot1OnClick}
          onKeyDown={handleScrollDot1OnKeyDown}
          role="button"
          tabIndex={0}
        />
        <div
          aria-label="Cardholder info panel"
          className={activeCard === 2 ? classes.active : classes.inactive}
          data-testid="dot-2"
          key={`dot-2-${activeCard}`}
          onClick={handleScrollDot2OnClick}
          onKeyDown={handleScrollDot2OnKeyDown}
          role="button"
          tabIndex={0}
        />
      </div>
    </>
  );
}

HorizontalImageList.propTypes = {
  imageList: PropTypes.arrayOf(PropTypes.elementType).isRequired,
  imageListProps: PropTypes.object,
};
